const STORAGE_KEY = 'ainsoft.printHeaderProfile.v1';

export const getDefaultPrintHeaderProfile = () => ({
  companyName: '',
  addressLine1: '',
  addressLine2: '',
  phone: '',
  email: '',
  website: '',
  registrationNo: '',
  note: '',
  customText: '',
  logoDataUrl: '',
  logoWidth: 86,
  logoHeight: 86,
  logoPosition: 'left',
  textAlign: 'left',
  selectedTemplateId: 'template-1',
  templateHtml: '',
  updatedAt: null
});

const sanitizeProfile = (value) => {
  const base = getDefaultPrintHeaderProfile();
  if (!value || typeof value !== 'object') {
    return base;
  }

  return {
    ...base,
    ...value,
    companyName: String(value.companyName || ''),
    addressLine1: String(value.addressLine1 || ''),
    addressLine2: String(value.addressLine2 || ''),
    phone: String(value.phone || ''),
    email: String(value.email || ''),
    website: String(value.website || ''),
    registrationNo: String(value.registrationNo || ''),
    note: String(value.note || ''),
    customText: String(value.customText || ''),
    logoDataUrl: String(value.logoDataUrl || ''),
    logoWidth: Number(value.logoWidth) > 0 ? Number(value.logoWidth) : 86,
    logoHeight: Number(value.logoHeight) > 0 ? Number(value.logoHeight) : 86,
    logoPosition: ['left', 'right', 'top'].includes(value.logoPosition) ? value.logoPosition : 'left',
    textAlign: ['left', 'center', 'right'].includes(value.textAlign) ? value.textAlign : 'left',
    selectedTemplateId: ['template-1', 'template-2', 'template-3', 'template-4', 'template-5'].includes(
      value.selectedTemplateId
    )
      ? value.selectedTemplateId
      : 'template-1',
    templateHtml: String(value.templateHtml || ''),
    updatedAt: value.updatedAt || null
  };
};

export const loadPrintHeaderProfile = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return getDefaultPrintHeaderProfile();
    const parsed = JSON.parse(raw);
    return sanitizeProfile(parsed);
  } catch (error) {
    console.error('Failed to load print header profile:', error);
    return getDefaultPrintHeaderProfile();
  }
};

export const savePrintHeaderProfile = (profile) => {
  const payload = sanitizeProfile({
    ...profile,
    updatedAt: new Date().toISOString()
  });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
};

export const downloadPrintHeaderProfile = (profile) => {
  const payload = sanitizeProfile({
    ...profile,
    updatedAt: new Date().toISOString()
  });
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: 'application/json'
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'print-header-profile.json';
  anchor.click();
  URL.revokeObjectURL(url);
};
